import { render, staticRenderFns } from "./SFXList.vue?vue&type=template&id=5d5879ad&scoped=true"
import script from "./SFXList.vue?vue&type=script&lang=js"
export * from "./SFXList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5879ad",
  null
  
)

export default component.exports